<script lang="ts">
import { defineComponent, ref } from 'vue'
import { newUserSessionPath } from '@/generated/railsRoutes'
import LogoBizHint from '@/components/logo/LogoBizHintDefault.vue'
import { useMediaQueryStore } from '@/stores/mediaQuery'

export default defineComponent({
  name: 'HeaderSignUp',

  components: {
    LogoBizHint,
  },

  props: {
    hasLogoLink: {
      type: Boolean,
      default: true,
    },

    hasSignInLink: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    // stores
    const mediaQueryStore = useMediaQueryStore()

    // refs
    const header = ref()

    return {
      // stores
      mediaQueryStore,

      // routes
      newUserSessionPath,

      // data
      header,
    }
  }
})
</script>

<template>
  <header
    ref="header"
    class="f-header">
    <div class="f-header--body">
      <div class="l-cols__header">
        <!-- ロゴ -->
        <div class="l-cols__header--col is-logo">
          <div class="l-unit__logo">
            <div class="l-unit__logo--description">
              <LogoBizHint
                :additional-style-class="['is-header']"
                :type="!mediaQueryStore.context.isUnderPhablet ? 'white' : 'default'"
                :has-link="hasLogoLink" />
            <!-- /.l-unit__logo description --></div>

            <div class="l-unit__logo--footer">
              <p class="p u-text__small u-text__white">
                クラウド活用と生産性向上の専門サイト
              </p>
            <!-- /.l-unit__logo footer --></div>
          <!-- /.l-unit__logo --></div>
        <!-- /.l-cols__header col --></div>

        <!-- ログイン -->
        <div
          v-if="hasSignInLink"
          class="l-cols__header--col is-signIn">
          <div class="o-action__signIn">
            <a
              class="o-action__signIn--item"
              :href="newUserSessionPath()">
              会員ログインはこちら
            </a>
          </div>
        <!-- /.l-cols__header col --></div>
      <!-- /.l-cols__header --></div>
    <!-- /.f-header body --></div>
  </header>
</template>

<style lang="sass" scoped>
// Foundation
.f-header
  $root: &
  width: 100%
  padding: 0 #{$global-prop-pc}px
  background-color: rgba($bg-black, 1)
  z-index: 5
  +transition($duration: $transition-middle)

  & &--body
    width: 100%
    max-width: #{$global-contents-width-pc}px
    min-height: 48px
    display: flex
    align-items: center
    position: relative
    margin: 0 auto

  +breakpoint($max-media: pc)
    padding: 0 #{$global-prop-sp}px

  +breakpoint
    background-color: transparent

    #{$root}--body
      height: 40px

// Layout
.l-unit__logo
  $root: &
  display: flex
  align-items: center

  & &--description
    width: 100%
    max-width: 115px

  & &--footer
    margin-left: 1em

  +breakpoint
    #{$root}--footer
      display: none

.l-cols__header
  $root: &
  width: 100%
  display: grid
  grid-template-columns: 1fr auto
  grid-template-rows: auto
  align-items: center

  & &--col
    line-height: 1

// Object
.o-action
  &__signIn
    $root: &

    & &--item
      color: $font-white
      font-size: $font-x-small
      text:
        align: center
        decoration: none
      +transition

      +mouseover
        text-decoration: underline

    +breakpoint
      #{$root}--item
        color: $font-black
</style>
